module.exports = __webpack_public_path__ + "img/kmt.d202159f.png";